import './Lace.css'

function Lace(){
    return(
        <div className="lace__watch"></div>
    )
}
export default Lace;